import { render, staticRenderFns } from "./OrganismUpdatingLicence.vue?vue&type=template&id=44763306&"
import script from "./OrganismUpdatingLicence.vue?vue&type=script&lang=js&"
export * from "./OrganismUpdatingLicence.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports